module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.d1554fe.woff2";